import {
  ArchiveBoxIcon,
  DocumentIcon,
  GlobeAltIcon,
  RectangleStackIcon,
  VideoCameraIcon,
} from '@heroicons/react/24/outline';
import { ModuleType } from 'types/domain/module';

export const ModuleTypeName = (type: ModuleType) => {
  switch (type) {
    case ModuleType.STANDARD:
      return 'Content';
    case ModuleType.PDF:
      return 'PDF';
    case ModuleType.SCORM:
      return 'SCORM';
    case ModuleType.WEBSITE:
      return 'Website';
    case ModuleType.YOUTUBE:
      return 'YouTube';
  }
};

export const ModuleTypeColor = (type: ModuleType) => {
  switch (type) {
    case ModuleType.STANDARD:
      return 'bg-[#A6F2E4]';
    case ModuleType.PDF:
      return 'bg-[#FFC9BD]';
    case ModuleType.SCORM:
      return 'bg-[#FFC9BD]';
    case ModuleType.WEBSITE:
      return 'bg-[#FFC9BD]';
    case ModuleType.YOUTUBE:
      return 'bg-[#FFC9BD]';
  }
};

export const ModuleTypeIcon = (type: ModuleType, className?: string) => {
  switch (type) {
    case ModuleType.STANDARD:
      return <RectangleStackIcon className={`${className} rotate-90`} />;
    case ModuleType.PDF:
      return <DocumentIcon className={className} />;
    case ModuleType.SCORM:
      return <ArchiveBoxIcon className={className} />;
    case ModuleType.WEBSITE:
      return <GlobeAltIcon className={className} />;
    case ModuleType.YOUTUBE:
      return <VideoCameraIcon className={className} />;
  }
};
